import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { TrimCommandManager } from '../command/trim.command.manager';
import { TrimPrintManager } from '../../print/trim.print';
import { TrimEditableImageManager } from '../editable-image/trim.editable-image.manager';
import { TrimPanZoomManager } from '../pan-zoom/trim.pan-zoom.manager';
import { initPictureFlags, TrimImageController } from './image/trim.image-controller';
import { NO_EDGE_TYPE, TrimFrameController } from './frame/trim.frame-controller';
import { TrimEditableEvent } from './trim.editable-event';
import { TrimImageEditableTool } from './image/trim.image-editable-tool';
import { TrimImageEvent } from './image/trim.image-event';
import { TrimEditableSideTool } from './trim.editable-side-tool';
import { TrimTextController } from './text/trim.text-controller';
import { TrimTextEvent } from './text/trim.text-event';
import { TrimThumbManager } from '../thumb/trim.thumb.manager';
import { TrimDataManager } from '../data/trim-data.manager';
import { UuidGenerator } from '../../../utilities/uuid-generator';
import * as createjs from 'createjs-module';
import { TrimCjBitmap, TrimCjContainer, TrimCjShape, TrimCjStage } from '../../model/cj-factory';
import { TrimRulerManager } from '../ruler/trim.ruler.manager';
import { TrimEditableEventCollection } from '../../model/trim.editable-event.collection';
import { Env } from '../../../models/env';
import { TrimPosManager } from '../pos/trim.pos.manager';
import { TrimTrimmingManager } from '../trimming/trim.trimming.manager';
import { CJ_BGIMAGE_NAME, CJ_CONTAINER_NAME } from '../../model/cj-factory/trim.cj-obj-name.collection';
import { padding, xmlActions } from '../../../xml/slice/xml-slice';
import { store } from '../../../app/store';
import { XmlStructureModel } from '../../../xml/model/xml-structure-model';
import { apiActions } from '../../../slices/api-slice';
import { ApiImagesGet } from '../../../api/front/images/api-images';
import { TrimEditableImage } from './trim.editable-image';
import { TrimCjTool } from '../../../utilities/trim.cj-tool';
import { TrimAdditionalManager } from '../additional/trim.additional.manager';
import { WindowsImgBugFix } from '../../../utilities/windows-img-bug-fix';
import { AcquiredTempInfo, layoutActions } from '../../../slices/layout-slice';
import { localStorageActions } from '../../../slices/local-storage-slice';
import { getExifColorSpaceWarningMessage } from '../../../utilities/exif-color-space-warning';
import { isEqual } from 'lodash';
import { TrimLayoutXmlUtile } from '../../model/trim.layout.xml.utile';
import { HashGenerator } from '../../../utilities/hash-generator';
import { TrimTempModel } from '../../model/trim.temp-model';
import PixelConverter from '../../../utilities/pixel-converter';
import { EditableImage } from '../../../layout-editor/manager/image-edit/editable-image';
import { ScreenColorType } from '../../../components/pages/layout/menu/layout.menu';
import { UiManager } from '../../../layout-editor/manager/ui/ui.manager';
import { CjTool } from '../../../utilities/cj-tool';
import { SCREEN_COLOR_CODE } from '../../../layout-editor/manager/image-edit/image-edit.manager';
import { INIT_PRINT_MENU, PrintTrimMenuType } from '../../../components/pages/sift/print-trim/hooks/use-print-trim';
import { WindowBase } from '../../model/trim.print-model';

export type PathType = {
  base: string,
  ad: string,
  name: string,
}

type GetEditableImageParam = {
  editableImage: TrimEditableImage;
  index: number;
}

export class TrimImageEditManager implements ITrimEditorManagerBase {
  // canvasの生成用data
  private readonly CANVAS_ID = UuidGenerator.create();
  static readonly CANVAS_W = 4000;
  static readonly CANVAS_H = 4000;
  // wrapperContainerの初期位置
  static readonly STAGE_CONTAINER_BASE_X = 2000;
  static readonly STAGE_CONTAINER_BASE_Y = 2000;
  static STAGE_CONTAINER_X = 2000;
  static STAGE_CONTAINER_Y = 2000;
  static readonly IMAGE_MAX_SIZE = 4000;
  public templateVirtual = {
    w: 0,
    h: 0,
  };
  public templateReal = {
    w: 0,
    h: 0,
  };
  public templateBaseVirtual = {
    w: 0,
    h: 0,
  };
  public templateBaseReal = {
    w: 0,
    h: 0,
  };
  public kijshopCd = '';
  public shopOrderId = '';
  public orderId = '';
  public xml: XmlStructureModel | null = null;
  public isAdditionalFrame: boolean = false;
  public isDAI: boolean = false;
  // private readonly BASE_URL = 'https://mercury.marietta.co.jp/share/labonet/template/';
  private readonly BASE_URL = `${Env.api.back.protocol}://${Env.api.back.host}/files/template`;

  public readonly path: PathType;
  // private readonly canvasWidth: number;
  // private readonly canvasHeight: number;
  private pageId: string = '';
  public printMenu: PrintTrimMenuType = INIT_PRINT_MENU;
  public isFit: boolean = false;
  public isSetEvent: boolean = false;

  private container: HTMLDivElement;
  private canvas: HTMLCanvasElement;
  private wrapperStage: TrimCjStage | null;
  public stage: TrimCjContainer | null;
  private guide: TrimCjBitmap | null;
  private draggingDom = false;

  private commandManager!: TrimCommandManager;
  private printManager!: TrimPrintManager;
  private editableImageManager!: TrimEditableImageManager;
  private panZoomManager!: TrimPanZoomManager;
  private trimDataManager!: TrimDataManager;
  private previewManager!: TrimThumbManager;
  private rulerManager!: TrimRulerManager;
  private posManager!: TrimPosManager;
  private trimmingManager!: TrimTrimmingManager;
  private imageController!: TrimImageController;
  private frameController!: TrimFrameController;
  private editableEvent!: TrimEditableEvent;
  private imageEditableTool!: TrimImageEditableTool;
  private imageEvent!: TrimImageEvent;
  private editableSideTool!: TrimEditableSideTool;
  private textController!: TrimTextController;
  private textEvent!: TrimTextEvent;
  private additionalManager!: TrimAdditionalManager;

  constructor(container: HTMLDivElement) {
    this.container = container;
    this.canvas = document.createElement('canvas');
    this.wrapperStage = null;
    this.stage = null;
    this.path = {
      base: '',
      ad: '',
      name: '',
    };
    this.guide = null;
  }

  initialize() {
    // this.initStage()
  }

  destroy(): void {
    // if (!this.container) return;
    // // - DOM のリセット -
    // this.deleteCanvasEle(this.container);
    // listener 削除
    // this.cjCanvas?.removeAllEventListeners();
    // TrimUiManager.ins.emit('r->t:center-line', { display: false });
    TrimUiManager.ins.emit('t->r:open-trim-menu', { isOpen: false });
    // this.editableSideTool.transparentAdditional('show');
    this.isSetEvent = false;
    TrimUiManager.ins.off('t->r:frame-fit:push', this.changeFitNum);
    TrimUiManager.ins.off('t->r:frame-fit:get', this.onFitNumGet);
    TrimUiManager.ins.off('r->t:change-screen-color', this.changeScreenColor);
    TrimUiManager.ins.emit('t->r:show-toast', { isToast: false, target: this.stage! });

    this.commandManager.clear();
    this.wrapperStage?.removeAllEventListeners();
    this.stage?.removeAllEventListeners();
    createjs.Ticker.removeAllEventListeners();
    TrimEditableEventCollection.forEach((e: any) => TrimUiManager.ins.off(e));
    window.removeEventListener('dragstart', this.detectionDraggingDom);

    this.imageController.destroy();
    this.frameController.destroy();
    this.editableEvent.destroy();
    this.imageEditableTool.destroy();
    this.imageEvent.destroy();
    this.editableSideTool.destroy();
    this.textController.destroy();
    this.textEvent.destroy();
    this.commandManager.destroy();

    try {
      this.container.removeChild(this.canvas);
      this.canvas.height = 0;
      this.canvas.width = 0;
      this.canvas.remove();
    } catch {
    }
  }

  di(
    commandMng: TrimCommandManager,
    albumMng: TrimPrintManager,
    editableMng: TrimEditableImageManager,
    panZoomMng: TrimPanZoomManager,
    LayoutStoreMng: TrimDataManager,
    previewMng: TrimThumbManager,
    rulerMng: TrimRulerManager,
    posMng: TrimPosManager,
    trimmingMng: TrimTrimmingManager,
    additionalMng: TrimAdditionalManager,
  ): void {
    this.commandManager = commandMng;
    this.printManager = albumMng;
    this.editableImageManager = editableMng;
    this.panZoomManager = panZoomMng;
    this.trimDataManager = LayoutStoreMng;
    this.previewManager = previewMng;
    this.rulerManager = rulerMng;
    this.posManager = posMng;
    this.trimmingManager = trimmingMng;
    this.additionalManager = additionalMng;
  }

  async initStage(param?: {
    kijshopCd: string,
    shopOrderId: string,
    orderId: string,
    initMenu: PrintTrimMenuType
  }) {
    if (param) {
      this.kijshopCd = param.kijshopCd;
      this.shopOrderId = param.shopOrderId;
      this.orderId = param.orderId;
      this.printMenu = param.initMenu;
    }
    if (!param) return;
    this.createCanvasEle();
    const canvas = this.getCanvasEle();
    this.canvas!.width = TrimImageEditManager.CANVAS_W;
    this.canvas!.height = TrimImageEditManager.CANVAS_H;
    this.container.appendChild(canvas);
    await this.standbyDefaultFont();
    // container.appendChild(this.canvas)
    // - stage の初期化 -
    await this.initTemplate();
    this.wrapperStage?.stage.update();
  }

  private detectionDraggingDom = () => {
    this.draggingDom = true;
  };

  async activateStage(kijshopCd: string, shopOrderId: string, orderId: string, initData: PrintTrimMenuType) {
    TrimUiManager.ins.on('t->r:frame-fit:push', this.changeFitNum);
    TrimUiManager.ins.on('t->r:frame-fit:get', this.onFitNumGet);
    TrimUiManager.ins.on('r->t:change-screen-color', this.changeScreenColor);
    window.addEventListener('dragstart', this.detectionDraggingDom);
    this.kijshopCd = kijshopCd;
    this.shopOrderId = shopOrderId;
    this.orderId = orderId;
    this.printMenu = initData;
    const printTrimData = this.printManager.printTrimData;

    if (printTrimData && printTrimData.config) {

      this.printMenu = {
        ...this.printMenu,
        isAllowMargin: !!printTrimData.config.space,
        modeInOut: TrimPrintManager.getTrimBaseType(printTrimData.config.trimBaseType),
      };
      console.log(this.printMenu, 'this.printMenu');
      TrimUiManager.ins.emit('t->r:image-resize-in/out/eq', {mode: this.printMenu.modeInOut})
      TrimUiManager.ins.emit('t->r:change-allow-margin', {isAllowMargin: this.printMenu.isAllowMargin})
    }

    this.imageController.initialize();
    this.frameController.initialize();
    this.editableEvent.initialize();
    this.imageEditableTool.initialize();
    await this.editableEvent.setEvent();
    if (!this.isSetEvent) {
      this.isSetEvent = true;
    }
    // this.imageEvent.initialize();
    this.editableSideTool.initialize();
    this.textController.initialize();
    this.textEvent.initialize();
    // - TrimThumbManager -
    const albumData = this.printManager.currentPrint;
    if (albumData && !albumData?.restoreMount) {
      // this.previewManager.start(this.canvas, this.albumManager.currentPrint!);
    }
    // // - TrimPanZoomManager -
    this.rulerManager.boot();
    this.panZoomManager.boot(this.canvas);
    if (!this.wrapperStage) return;
    this.trimmingManager.boot(this.stage!, this.trimDataManager, this.pageId);

    // --- 特定の要素以外クリックでフォーカスを外す ---
    this.wrapperStage?.addEventListener('click', (e) => {
      // if (this.imageEvent.isMove && this.imageEvent.dragTarget) {
      //   console.log(this.imageEvent.dragTarget, 'dragTarget');
      //   this.imageEvent.handleMoveEnd(this.imageEvent.dragTarget, e);
      //   const container: TrimCjContainer = this.trimDataManager.getImageArea();
      //   TrimCjTool.getHighlight(container).visible = false;
      // }
      if (this.trimmingManager) {
        if (this.trimmingManager.trimGuides) {
          this.trimmingManager.moveEnd();
        }
      }
      if (this.textEvent.targetFrame) {
        this.editableEvent.disFocused(this.textEvent.targetFrame);
      } else if (this.imageEvent.targetFrame) {
        this.editableEvent.disFocused(this.imageEvent.targetFrame, true);
      }
    });
    // TrimUiManager.ins.emit('r->t:image-guide-on/off', { mode: initData.modeAbleArea });
    TrimUiManager.ins.emit('r->t:image-resize-in/out/eq', { mode: this.printMenu.modeInOut });
    // TrimUiManager.ins.emit('r->t:center-line', { display: initData.display });
    // TrimUiManager.ins.emit('t->r:frame-fit:push', { fitNum: 20 });
    TrimUiManager.ins.emit('r->t:change-operation-cursor', { mode: 'select' });
    // TrimUiManager.ins.emit('r->t:transparent-additional', {
    //   type: initData.additionalShow, callback: () => {
    //   },
    // });
    TrimUiManager.ins.emit('t->r:show-toast', { isToast: this.isFit, target: this.stage! });
    this.printMenu.screenColor = initData.screenColor;
    this.changeScreenColor(this.printMenu);
    this.wrapperStage.stage.snapToPixelEnabled = true;
    // -- ステージの再描画処理 --
    // NOTE: RAF(RequestAnimationFrame)モード。60FPS
    // createjs.Ticker.timingMode = createjs.Ticker.RAF
    createjs.Ticker.addEventListener('tick', this.wrapperStage);
  }

  deactivateStage(container: HTMLDivElement) {
    // this.editableSideTool.unlock();
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    this.destroy();
    try {
      container.removeChild(this.canvas);
      this.canvas.height = 0;
      this.canvas.width = 0;
      this.canvas.remove();
    } catch {
    }
  }

  getCanvasEle() {
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    return this.canvas;
  }

  setCanvasData() {
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    this.canvas.width = TrimImageEditManager.CANVAS_W;
    this.canvas.height = TrimImageEditManager.CANVAS_H;
  }

  removeCanvasData() {
    if (!this.canvas) {
      throw new Error('this.canvas is null !!');
    }
    this.destroy();
    this.canvas.height = 0;
    this.canvas.width = 0;
    this.canvas.remove();
  }

  activateAllFocus() {
    const container: TrimCjContainer = this.trimDataManager.getEditor();
    container.mouseEnabled = true;
    TrimUiManager.ins.emit('t->r:wait-loading', { message: '' });
  }

  resizeStage() {
    const print = this.printManager.currentPrint;
    const base = print?.base;
    const template = base?.getImageWindow();
    if ( !print || !base || !template) {
      throw new Error('template not found !!!!')
    }
    const fills = base.getFillWindow();
    const edgeTmp = this.printManager.getEdge(template.virtual.wh, fills);
    // NOTE: フチなしの商品と白フチ商品の判別がテンプレートではできないためハードコーディング
    const isNoEdge = print.item.productData?.meta?.borderType === NO_EDGE_TYPE;

    this.templateReal.w = template.real.wh.width;
    this.templateReal.h = template.real.wh.height;
    this.templateVirtual.w = template.virtual.wh.width;
    this.templateVirtual.h = template.virtual.wh.height;


    // this.templateBaseVirtual.w = edgeTmp ? edgeTmp.virtual.wh.width : template.virtual.wh.width;
    // this.templateBaseVirtual.h = edgeTmp ? edgeTmp.virtual.wh.height : template.virtual.wh.height;
    this.templateBaseVirtual.w = isNoEdge ? template.virtual.wh.width : template.virtual.wh.width + (template.virtual.pos.x * 2);
    this.templateBaseVirtual.h = isNoEdge ? template.virtual.wh.height : template.virtual.wh.height + (template.virtual.pos.y * 2);
    TrimImageEditManager.STAGE_CONTAINER_X = TrimImageEditManager.STAGE_CONTAINER_BASE_X - this.templateBaseVirtual.w/2
    TrimImageEditManager.STAGE_CONTAINER_Y = TrimImageEditManager.STAGE_CONTAINER_BASE_Y - this.templateBaseVirtual.h/2
  }

  createCanvasEle() {
    // テンプレートのサイズ
    // canvas作成
    this.canvas.id = this.CANVAS_ID;
    this.canvas.width = TrimImageEditManager.CANVAS_W;
    this.canvas.height = TrimImageEditManager.CANVAS_H;
    // テンプレートのサイズをcanvasのサイズにする
    this.resizeStage();
    // - canvas へのイベントの付与 -
    this.canvas.addEventListener('dragover', (e) => {
      e.preventDefault();
      if (!(e.currentTarget instanceof HTMLCanvasElement)) {
        throw new Error('e.currentTarget is not instance of HTMLCanvasElement !!');
      }
      const scale = this.panZoomManager.scale;
      const boundingRect = e.currentTarget.getBoundingClientRect();
      const x = (e.clientX - boundingRect.x) / scale;
      const y = (e.clientY - boundingRect.y) / scale;
      TrimUiManager.ins.emit('r->t:editable-image:drag:check', { x, y });
      // }
    });

    const addImage = (files: File[], isPng?: boolean) => {
      if (this.imageEvent.activeFocus) return;
      const target: TrimCjContainer = this.trimDataManager.getImageArea();
      if (!target.isChecked) {
        this.activateAllFocus();
        return;
      }
      if (!target.logoFlag && isPng) {
        TrimUiManager.ins.emit('t->r:push-dialog', {
          title: '確認',
          message: ['PNG形式の画像のため合成することができません。'],
          buttons: [
            {
              label: 'OK',
              callback: () => {
                this.activateAllFocus();
              },
            },
          ],
        });
        return;
      }
      TrimUiManager.ins.emit('t->r:wait-loading', { message: '画像の合成中です...' });
      this.getPhotoImage({ files });
    };

    // - 画像のdrop -
    this.canvas.addEventListener('drop', (e) => {
      e.preventDefault();
      if (this.editableImageManager.flags.dragging) {
        // -- ドローワーからのDnD --
        TrimUiManager.ins.emit('r->t:editable-image:drop');
        this.draggingDom = false;
      } else if (e.dataTransfer?.files.length && !this.draggingDom) {
        // -- ローカルからの直接のDnD --
        const target: TrimCjContainer = this.trimDataManager.getImageArea();
        const photoAreaCount = 1;

        const _files = !target?.logoFlag
          ? Array.from(e.dataTransfer.files).filter((v) => /\.(jpe?g)$/i.test(v.name))
          : Array.from(e.dataTransfer.files).filter((v) => /\.(jpe?g)$/i.test(v.name) || /\.(png)$/i.test(v.name));
        const isPng = Array.from(e.dataTransfer.files).filter((v) => /\.(png)$/i.test(v.name)).length === 1;
        const files = _files.slice(0, photoAreaCount);
        // Windows でのバグチェック
        // Windows のバグのせいでドロワーからなのにローカルから判定される
        if (!WindowsImgBugFix.check(files) && target) {
          const highlight = TrimCjTool.getHighlight(target);
          highlight.visible = false;
          TrimUiManager.ins.emit('r->t:editable-image:drop');
          this.activateAllFocus();
          return;
        }
        if (!files.length && target) {
          const highlight = TrimCjTool.getHighlight(target);
          highlight.visible = false;
        }
        if (target?.logoFlag && e.dataTransfer.files.length > 1) {
          const highlight = TrimCjTool.getHighlight(target);
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              `対象の写真エリアはロゴタイプです。`,
              `画像を複数枚設置することはできません。`,
              `先頭の画像のみ配置します。`,
            ],
            buttons: [{
              label: 'OK', callback: () => {
                highlight.visible = false;
              },
            }],
          });
          this.activateAllFocus();
          return;
        } else if (target?.logoFlag && e.dataTransfer.files.length === 1) {
          addImage(_files, isPng);
        } else if (photoAreaCount >= e.dataTransfer.files.length) {
          addImage(files, isPng);
        } else {
          TrimUiManager.ins.emit('t->r:push-dialog', {
            title: '確認',
            message: [
              `選択された画像の枚数がこのページの写真エリアの数を超えています。`,
              `このページに配置できる写真枚数は ${photoAreaCount}枚です。`,
              `配置できる枚数だけを配置する場合は「はい」、`,
              `中止する場合は「いいえ」をクリックしてください。`,
            ],
            buttons: [
              {
                label: 'いいえ',
                callback: () => {
                  this.activateAllFocus();
                  return;
                },
              },
              {
                label: 'はい',
                callback: () => {
                  addImage(files, isPng);
                },
              },
            ],
          });
        }
      } else {
        this.editableEvent.cancelDraggingFunc();
        this.draggingDom = false;
      }
    });
  }

  // - templateの初期化 -
  private async initTemplate() {
    if (!this.canvas) {
      throw new Error('There is no canvas !!');
    }
    // - createJSのCanvas -
    this.wrapperStage = new TrimCjStage(this.canvas);
    // - event判定用の背景 -
    const blackBack = new TrimCjShape();
    blackBack.name = CJ_BGIMAGE_NAME.blackback;
    blackBack.graphics.f('#000').dr(0, 0, TrimImageEditManager.CANVAS_W, TrimImageEditManager.CANVAS_H);
    this.wrapperStage.addChild(blackBack);
    // - createJSのCanvas -
    this.stage = new TrimCjContainer();
    this.stage.x = TrimImageEditManager.STAGE_CONTAINER_X;
    this.stage.y = TrimImageEditManager.STAGE_CONTAINER_Y;
    this.stage.name = CJ_CONTAINER_NAME.stage;
    this.wrapperStage.addChild(this.stage);
    // - サムネに異常があった場合 -
    // this.path.base = this.printManager.currentPrint?.dirName ?? '';
    // - サムネのパスから基準のパスを作る(dirNameはCoverを考慮していないためaddPathを用意) -
    // const thumbnailPath = this.printManager.currentPrint?.thumbnail.templatePath;
    // const fullPath = thumbnailPath?.substr(0, thumbnailPath?.indexOf('/thumbnail.jpg')) ?? this.path.base;
    // - テンプレートのパス部分だけ抽出 -
    // this.path.ad = fullPath.substr(fullPath.indexOf(this.BASE_URL) + this.BASE_URL.length);
    // - pathからテンプレート名を抽出 -
    const dirNames = this.path.ad.split('/');
    this.path.name = dirNames[dirNames.indexOf('template') + 3] ?? '';

    this.pageId = this.printManager.currentPrint?.id ?? `layout-order:${UuidGenerator.create()}`;
    this.stage.pageId = this.pageId;
    // this.pageId = `layout-order:${UuidGenerator.create()}`;
    // const isRestore = !this.printManager.currentPrint?.isChange;
    // const album = this.printManager.currentPrint?.parseData;
    // if (album.templateData?.additionalFrame) {
    //   this.isAdditionalFrame = !!album.templateData.additionalFrame[0].$.frameID;
    //   this.isDAI = true;
    //   this.layoutDataManager.dispatch('setFocusMode', 'DAI');
    // }

    // - 画像の取得先 -
    const url = this.BASE_URL + this.path.ad;
    await this.initIns(this.stage, this.path, url, this.pageId);
    await this.initDi();
    const orderPage = (() => {
      if (this.printManager.currentPrint?.restoreMount) {
        const xml = store.getState().xml[this.shopOrderId];
        const orderInfo = xml?.orderInfo?.infoData?.find((info) => info.xml.metaModel.id === this.orderId);
        orderInfo && (this.imageController.orderInfo = orderInfo);
        const optionInfo = TrimLayoutXmlUtile.getOptionInfoData(this.orderId, xml);
        const optionParts = TrimLayoutXmlUtile.flatOptionParts(optionInfo);
        const orderParts = orderInfo?.parts?.partsData?.concat(optionParts);
        const orderPages = orderParts?.map((elm) => elm.page?.pageData).flat();
        // const currentAlbumPath = this.printManager.currentPrint?.indexes;
        // const _orderPage = orderPages?.find((page) => isEqual(page?._indexes, currentAlbumPath));
        // return _orderPage;
      } else {
        return undefined;
      }
    })();
    if (orderPage) {
      this.frameController.orderPage = orderPage;
      this.imageController.orderPage = orderPage;
      // this.textController.orderPage = orderPage;
    }
    // await this.frameController.createBgImage(this.path.ad, url);
    // await this.frameController.createPhotoFrame(this.path.ad, url);
    this.frameController.createEdge();
    this.frameController.createBgImage();
    await this.frameController.createPhotoArea();
    await this.textController.createDateText();
    this.frameController.createGuide();
    await this.textController.restoreText();
    await this.imageController.restorePNG();

    // this.stage.addChild(this.printManager.editableImage!.editable)
    // await this.frameController.createAdditional();
    // await this.frameController.createOverWrap(this.path.ad, url);
    // await this.frameController.createGuide(this.path.ad, url);
    // await this.frameController.createGrayOut();
    // await this.frameController.createMask();
    // if (isRestore) {
    //   await this.imageController.restore();
    // }
    await this.frameController.createStageMask(SCREEN_COLOR_CODE[this.printMenu.screenColor]);
    if (!this.printManager.currentPrint?.restoreMount) {
      TrimUiManager.ins.emit('t->r:wait-loading2', { message: '' });
    }
  }

  get getBaseUrl() {
    return this.BASE_URL;
  }

  // - 台紙形状変化時の更新メソッド -
  async updateTemplate(temp: AcquiredTempInfo, images: TrimEditableImage[], initData: PrintTrimMenuType) {
    if (!this.wrapperStage) return;
    // this.printManager.currentPrint!.parseData = temp.template;
    // this.printManager.currentPrint!.thumbnail.image = temp.thumbnail;
    // this.printManager.currentPrint!.thumbnail.templatePath = temp.thumbnail;
    this.wrapperStage.removeAllChildren();
    // - createJSのCanvas -
    this.stage = new TrimCjContainer();
    this.stage.x = TrimImageEditManager.STAGE_CONTAINER_X;
    this.stage.y = TrimImageEditManager.STAGE_CONTAINER_Y;
    this.stage.name = CJ_CONTAINER_NAME.stage;
    this.wrapperStage.addChild(this.stage);

    // const tempSize = this.printManager.currentPrint?.parseData.templateData.size[0].virtual[0].$;
    // this.templateVirtual.w = tempSize.width;
    // this.templateVirtual.h = tempSize.height;
    // - サムネに異常があった場合 -
    // this.path.base = this.printManager.currentPrint?.dirName ?? '';
    // - サムネのパスから基準のパスを作る(dirNameはCoverを考慮していないためaddPathを用意) -
    // const thumbnailPath = this.printManager.currentPrint?.thumbnail.templatePath;
    // const fullPath = thumbnailPath?.substr(0, thumbnailPath?.indexOf('/thumbnail.jpg')) ?? this.path.base;
    // - テンプレートのパス部分だけ抽出 -
    // this.path.ad = fullPath.substr(fullPath.indexOf(this.BASE_URL) + this.BASE_URL.length);
    // - pathからテンプレート名を抽出 -
    const dirNames = this.path.ad.split('/');
    this.path.name = dirNames[dirNames.indexOf('template') + 3] ?? '';
    // - 画像の取得先 -
    const url = this.BASE_URL + this.path.ad;
    this.updateIns(this.stage, this.path, url);
    // await this.frameController.createPhotoFrame();
    // await this.frameController.createGuide(this.path.ad, url, true);
    // await this.frameController.createGrayOut();
    // await this.frameController.createStageMask(SCREEN_COLOR_CODE[this.screenColor]);

    TrimUiManager.ins.emit('r->t:image-guide-on/off', { mode: initData.modeAbleArea });
    TrimUiManager.ins.emit('r->t:image-resize-in/out/eq', { mode: initData.modeInOut });
    // TrimUiManager.ins.emit('t->r:frame-fit:push', { fitNum: 20 });

    const editor = this.trimDataManager.getEditor();
    await  new Promise<void>((resolve) => {
      const img = images.find((v) => v.photoAreaId === editor.photoAreaId);
      if (img) {
        const index = this.printManager.currentPrint?.editableIDList.findIndex((v) => v === img.id);
        if (index !== undefined && index > -1) {
          this.printManager.currentPrint?.editableIDList.splice(index, 1);
        }
      } else {
        this.trimmingManager.reboot(this.stage!);
        resolve();
      }
    });
  }

  // - インスタンス用意 -
  private initIns(stage: TrimCjContainer, path: PathType, url: string, pageId: string) {
    this.imageController = new TrimImageController(stage, pageId);
    this.imageEditableTool = new TrimImageEditableTool(stage, pageId);
    this.imageEvent = new TrimImageEvent(stage);
    this.frameController = new TrimFrameController(stage, pageId);
    this.editableSideTool = new TrimEditableSideTool(stage, pageId);
    this.editableEvent = new TrimEditableEvent(stage, path, url, pageId);
    this.textController = new TrimTextController(stage, pageId);
    this.textEvent = new TrimTextEvent(stage, pageId);
  }

  // - インスタンス用意 -
  private updateIns(stage: TrimCjContainer, path: PathType, url: string) {
    this.imageController.update(stage);
    this.imageEditableTool.update(stage);
    this.imageEvent.update(stage);
    this.frameController.update(stage);
    this.editableSideTool.update(stage);
    this.editableEvent.update(stage, path, url);
    this.textController.update(stage);
    this.textEvent.update(stage);
  }

  // - インスタンスのDI -
  private initDi() {
    this.imageController.di(
      this.frameController,
      this.printManager,
      this.editableImageManager,
      this.panZoomManager,
      this.imageEvent,
      this.imageEditableTool,
      this.trimDataManager,
      this.editableEvent,
      this.editableSideTool,
      this,
    );
    this.imageEditableTool.di(
      this.imageController,
      this.frameController,
      this.editableImageManager,
      this.imageEvent,
      this.trimDataManager,
      this.editableEvent,
      this,
      this.textEvent,
      this.printManager,
    );
    this.imageEvent.di(
      this.imageController,
      this.frameController,
      this.panZoomManager,
      this.editableEvent,
      this.editableSideTool,
      this.imageEditableTool,
      this.trimDataManager,
      this.editableImageManager,
      this.posManager,
      this,
      this.textEvent,
      this.trimmingManager,
    );
    this.frameController.di(
      this.imageController,
      this.printManager,
      this.editableImageManager,
      this.imageEvent,
      this.imageEditableTool,
      this.trimDataManager,
      this.additionalManager,
      this,
      this.editableEvent,
      this.editableSideTool,
      this.textController,
    );
    this.editableSideTool.di(
      this,
      this.frameController,
      this.imageController,
      this.editableImageManager,
      this.imageEvent,
      this.textController,
      this.trimDataManager,
      this.editableEvent,
      this.printManager,
      this.panZoomManager,
    );
    this.editableEvent.di(
      this.frameController,
      this.imageController,
      this.commandManager,
      this.editableImageManager,
      this.panZoomManager,
      this.imageEditableTool,
      this.textController,
      this.textEvent,
      this.editableSideTool,
      this.imageEvent,
      this.trimDataManager,
      this.rulerManager,
      this.trimmingManager,
      this.posManager,
      this.printManager,
      this,
    );
    this.textController.di(
      this.textEvent,
      this.trimDataManager,
      this.editableEvent,
      this.posManager,
      this.printManager,
      this,
    );
    this.textEvent.di(
      this.textController,
      this.imageEvent,
      this.editableEvent,
      this.posManager,
      this.trimDataManager,
    );
  }

  private deleteCanvasEle(container: HTMLDivElement) {
    if (this.canvas) {
      container.removeChild(this.canvas);
      // this.canvas = null;
    }
  }

  private onFitNumGet: (v: { callback: (p: { fitNum: number }) => void }) => void = (v: {
    callback: (p: { fitNum: number }) => void
  }) => {
    v.callback({ fitNum: this.imageController.fitNum });
  };
  private changeFitNum: (v: { fitNum: number }) => void = (v: { fitNum: number }) => {
    this.imageController.fitNum = v.fitNum;
    this.trimDataManager.setFitNum(v.fitNum)
    TrimUiManager.ins.emit('t->r:frame-fit:change', { fitNum: v.fitNum });
  };

  private changeScreenColor = (v: PrintTrimMenuType) => {
    const nextColor = v.screenColor;
    if (this.printMenu.screenColor !== nextColor) {
      this.printMenu.screenColor = nextColor;
      console.log(nextColor);
      if (!this.stage) return;
      const prevMask = CjTool.getStageMask(this.stage);
      if (prevMask) {
        this.stage?.removeChild(prevMask);
        this.frameController.createStageMask(SCREEN_COLOR_CODE[nextColor]);
      }
    }
  }

  private standbyDefaultFont = async () => {
    return new Promise<void>((resolve) => {
      TrimUiManager.ins.emit(
        't->r:web-font:get-list',
        {
          callback: (e: { fonts: string[] }) => {
            const fontList = e.fonts.map((v, i) => ({ value: v, label: v }));
            store.dispatch(layoutActions.setInitFontList(fontList));
            if (fontList[0]) {
              TrimUiManager.ins.emit('t->r:web-font:download', {
                fontFamilyName: fontList[0].label,
                callback: () => {
                  resolve();
                },
                error: (msg: string) => {
                  resolve();
                },
              });
            }
          },
        },
      );
    })
  };

  private getPhotoImage(param: {
    files: File[],

  }): Promise<GetEditableImageParam | null> {
    const { files } = param;
    const orderSelect = store.getState().xml[this.shopOrderId]?.orderSelect?.metaModel.imageData ?? [];
    // const orderSelect = this.xml?.orderSelect?.metaModel.imageData ?? [];
    return new Promise((resolve) => {
      let exifFlg = false;
      TrimUiManager.ins.emit(
        'r->t:add-image',
        {
          files: files,
          // files: Array.from(e.dataTransfer.files),
          kijshopCd: this.kijshopCd,
          shopOrderId: this.shopOrderId,
          orderId: this.orderId || null,
          samePushIgnore: true,
          selectIdList: [...(orderSelect.map((v) => ({
            path: v.selectFileName?.real.path || '',
            selectID: v.selectID || '',
          })))],
          onCreatedEditableImage: (e) => {
            TrimUiManager.ins.emit('r->t:editable-image:drop:direct', {
              editableImage: e.editableImage,
              index: e.index,
              callback: () => {
                const stopWarning = store.getState().storage.isStopDialog.exifWarning;
                if (String(e.editableImage.exif.colorSpace) !== '1' && !exifFlg && !stopWarning) {
                  exifFlg = true;
                  TrimUiManager.ins.emit('t->r:push-dialog', {
                    title: '確認',
                    message: getExifColorSpaceWarningMessage(e.editableImage.exif.colorSpace),
                    buttons: [{
                      label: 'OK',
                      callback: () => {
                      },
                    }],
                    remind: {
                      callback: (v) => store.dispatch(localStorageActions.setIsStopDialog({ key: 'exifWarning', value: v })),
                    },
                  });
                }
              },
            });
          },
          onUploaded: (e) => {
            if (e.sameImage) return;
            store.dispatch(xmlActions.uploadImage({
              kijshopCd: this.kijshopCd,
              shopOrderId: this.shopOrderId,
              // TODO アサーションを回避する
            }).layout(this.orderId || '').add(e.editableImage as EditableImage, (res) => {
              store.dispatch(layoutActions.setSaveSelect(res));
            }));
          },
        },
      );
    });
  }

}
